import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getPlatformFee, savePlatformFee } from "store/platform-fees"

export function useCardProcessingFee({ enabled = false } = {}) {
  const dispatch = useDispatch()
  const platformFeeData = useSelector((state) => state.platformFees?.data)
  const isLoading = useSelector((state) => state.platformFees?.loading || false)
  const isSaving = useSelector((state) => state.platformFees?.save?.loading || false)

  const [passFeeToGuest, setPassFeeToGuest] = useState(false)

  useEffect(() => {
    if (enabled) dispatch(getPlatformFee())
  }, [dispatch, enabled])

  useEffect(() => {
    if (platformFeeData) {
      setPassFeeToGuest(platformFeeData.card_fee_passthrough_enabled ?? false)
    }
  }, [platformFeeData])

  const handleToggle = async (checked) => {
    setPassFeeToGuest(checked)
    await dispatch(savePlatformFee({ card_fee_passthrough_enabled: checked }))
  }

  return { passFeeToGuest, handleToggle, isLoading, isSaving }
}
